<template>
  <div class="hr-recruitment-details">
    <div class="hr-recruitment-details__header">
      <div class="hr-recruitment-details__title-container">
        <h2 class="hr-recruitment-details__title">Recruitment informations</h2>
      </div>

      <v-btn
        depressed
        :class="['hr-recruitment-details__status',
        `hr-recruitment-details__status--${serializedStatus(recruitmentData.status)}`]"
        @click="editStatus"
      >
        {{ recruitmentData.status }}
      </v-btn>
      <v-btn
        class="hr-recruitment-details__toggle-btn"
        :class="{ 'hr-recruitment-details__toggle-btn--open': isContentVisible }"
        fab
        x-small
        depressed
        color="blue-light"
        @click="toggleVisibility"
      >
        <v-icon color="blue">mdi-chevron-down</v-icon>
      </v-btn>
    </div>

    <v-slide-y-transition>
      <div
        v-show="isContentVisible"
        class="hr-recruitment-details__content"
      >
        <h3 class="hr-recruitment-details__position">{{ recruitmentData.position }}</h3>

        <v-row class="hr-recruitment-details__base-info">
          <v-col class="col-12 col-lg-6">
            <div v-if="recruitmentData.experience_in_years" class="project-details">
              <div class="project-details__icon">
                <img src="@/assets/img/icon-team-members.svg" alt="Experience icon">
              </div>
              <div class="project-details__wrapper">
                <label class="project-details__label">Minimum experience</label>
                <p class="project-details__data">
                  {{ recruitmentData.experience_in_years }}
                </p>
              </div>
            </div>
            <div v-if="recruitmentData.rate" class="project-details">
              <div class="project-details__icon">
                <img src="@/assets/img/icon-money.svg" alt="Rate icon">
              </div>
              <div class="project-details__wrapper">
                <label class="project-details__label">Rate</label>
                <p class="project-details__data">
                  {{ recruitmentData.rate }} PLN / h
                </p>
              </div>
            </div>
          </v-col>

          <v-col class="col-12 col-lg-6">
            <div v-if="recruitmentData.level" class="project-details">
              <div class="project-details__icon">
                <img src="@/assets/img/icon-team-members.svg" alt="Level icon">
              </div>
              <div class="project-details__wrapper">
                <label class="project-details__label">Level</label>
                <p class="project-details__data">
                  {{ recruitmentData.level }}
                </p>
              </div>
            </div>
            <div v-if="recruitmentData.start_date" class="project-details">
              <div class="project-details__icon">
                <img src="@/assets/img/icon-project-details.svg" alt="Project term icon">
              </div>
              <div class="project-details__wrapper">
                <label class="project-details__label">Project term</label>
                <p class="project-details__data">
                  {{ recruitmentData.start_date | displayDate }}
                  -
                  {{ recruitmentData.end_date | displayDate }}
                </p>
              </div>
            </div>
          </v-col>
        </v-row>

        <div class="hr-recruitment-details__features">
          <v-row>
            <v-col class="col-12 col-lg-6">
              <h3 class="hr-recruitment-details__group-title">
                Technologies
              </h3>
              <FeaturesList
                v-if="recruitmentData.technologies && recruitmentData.technologies.length"
                :features="recruitmentData.technologies"
                primary
                :editable="false"
              />
            </v-col>
            <v-col class="col-12 col-lg-6">
              <h3 class="hr-recruitment-details__group-title">
                Language
              </h3>
              <FeaturesList
                v-if="recruitmentData.languages && recruitmentData.languages.length"
                :features="recruitmentData.languages"
                :editable="false"
              />
            </v-col>
            <v-col class="col-12 col-lg-6">
              <h3 class="hr-recruitment-details__group-title">
                Project areas
              </h3>
              <FeaturesList
                v-if="recruitmentData.project_areas && recruitmentData.project_areas.length"
                :features="recruitmentData.project_areas"
                :editable="false"
              />
            </v-col>
          </v-row>
        </div>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import FeaturesList from '@/components/Developers/Show/FeaturesList.vue';

export default {
  components: {
    FeaturesList,
  },

  props: {
    recruitmentData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isContentVisible: true,
      isStatusModalVisible: false,
      isSubmitProcessing: false,
    };
  },

  computed: {
    teamSizeDisplay() {
      let displaySize;
      switch (this.projectData.team_size) {
        case 'small':
          displaySize = '1-5';
          break;
        case 'medium':
          displaySize = '6-9';
          break;
        case 'large':
          displaySize = '10+';
          break;
        default:
          break;
      }
      return displaySize;
    },
  },

  methods: {
    toggleVisibility() {
      this.isContentVisible = !this.isContentVisible;
    },

    serializedStatus(status) {
      return status.replace(/ /g, '').toLowerCase();
    },

    editStatus() {
      this.$emit('edit-status');
    },
  },
};
</script>

<style lang="scss" scoped>
.hr-recruitment-details {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;
  transition: all 0.4s ease;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    color: $main--headers;
  }

  &__toggle-btn {
    transition: all 0.4s ease;
    &--open {
      transform: rotate(180deg);
    }
  }


  &__status {
    font-size: 14px;
    background: $color--green !important;
    border-radius: 4px;
    color: #fff;
    padding: 6px 14px;
    text-transform: capitalize;
    margin-right: 16px;
    margin-left: auto;

    &--urgent {
      background: $color--yellow !important;
    }
    &--basic {
      background: $color--green !important;
    }
    &--asap {
      background: $color--red !important;
    }
  }

  &__position {
    color: $main--headers;
    margin-top: 12px;
    font-size: 18px;
    line-height: 21px;
    font-weight: bold;
  }

  &__data {
    flex-grow: 1;
    margin: 16px 0;

    @include tablet {
      margin: 0 0 0 24px;
    }
  }

  &__title {
    color: $main--headers;
    font-size: 20px;
    line-height: 24px;
    a {
      text-decoration: unset !important;
      color: $main--headers;
    }
  }

  &__features {
    margin-top: 16px;
  }

  &__group-title {
    margin-bottom: 12px;
    font-weight: 500;
    color: $main--headers;
  }
}

.project-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  &__icon {
    margin-right: 8px;
    margin-top: 10px;

    img {
      height: 24px;
      margin-right: 8px;
    }
  }

  &__label {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 0;
  }
  &__data {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 0;
    font-weight: 500;
  }
}
</style>
